// MEGA MENU //
/**
 * Show specific product images when hovering over a menu item in the mega menu.
 * @param {string} classElemsToHide - The class selector of elements to hide.
 * @param {string} classElemToShow - The class selector of the element to show.
 */
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
	var imageContainers = document.querySelectorAll(classElemsToHide);
	imageContainers.forEach(function(imageContainer){
		imageContainer.style.display = 'none';
	})
	document.querySelector(classElemToShow).style.display = 'grid';
}

/**
 * Adjust the position of the mega menu to be aligned with the header height.
 */
function getMegaMenuPosition() {
	var menuElems = document.querySelectorAll('.mm-header-link');
	var header = document.querySelector('.mm-section-header');
	var headerHeight = header.offsetHeight;

	menuElems.forEach(function(menuElem) {
		if (menuElem.nextElementSibling) {
			if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper') || menuElem.nextElementSibling.classList.contains('mm-header-submenu')) {
				menuElem.nextElementSibling.style.top = `${headerHeight}px`;
			}
		}
	})
}

// FILTER //
/**
 * Handle background filter visibility when hovering over mega menu links.
 */
function hoverBgFilter() {
	const header = document.querySelector('.mm-header');
	const megaMenuLinks = document.querySelectorAll('.mm-header-link-mega-menu');
	const filter = document.querySelector('.mm-filter-mega-menu');
	const search = document.querySelector('.mm-header-search-container');
	megaMenuLinks.forEach(megaMenuLink => {
		megaMenuLink.addEventListener('mouseenter', () => {
			filter.classList.add("active");
			document.querySelector("html").classList.add("stop-scrolling");
		});
		header.addEventListener('mouseleave', () => {
			filter.classList.remove("active");
			search.classList.remove("mm-open");
			document.querySelector("html").classList.remove("stop-scrolling");
		});
	});
}

/**
 * Display the background filter.
 */
function showBgFilter() {
	const filter = document.querySelector('.mm-filter-mega-menu');
	filter.style.zIndex = 'var(--index)';
	filter.classList.add("active");
}

/**
 * Hide the background filter.
 */
function hideBgFilter() {
	const filter = document.querySelector('.mm-filter-mega-menu');
	filter.style.removeProperty('z-index');
	filter.classList.remove("active");
}

/**
 * Ensure external links open in a new tab with appropriate security attributes.
 */
function externalLink() {
	var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].classList.contains('mm-internal-link') && links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
}

// MOBILE MENU //
/**
 * Init the position of the mobile menu and manage related UI changes.
 */
function mmInitMobileMenu() {
	if (window.innerWidth <= 1200) {
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
		const mobileMenuSecondary = document.querySelector(".mm-mobile-menu-wrapper .mm-header-mobile-sublinks");
		let headerMenu = document.querySelector('.mm-header');
		let headerHeight = headerMenu.offsetHeight;
		let headerMenuTop = headerMenu.getBoundingClientRect().top;
		mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
		mobileMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
		mobileMenuSecondary.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;

		if (window.innerWidth <= 768) {
			mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
			mobileMenuSecondary.style.top = 0;
			mobileMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
		}
	}
}

/**
 * Toggle the visibility of the mobile menu and manage related UI changes.
 */
function mmMobileMenu() {
	if (window.innerWidth <= 1200) {
		const filter = document.querySelector('.mm-filter-mega-menu');
		const header = document.querySelector("header");
		const icon = document.querySelector(".mm-header-burger");
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

		filter.classList.add("active");
		header.classList.toggle("mm-open");
		icon.classList.toggle("mm-open");
		mobileMenu.classList.toggle("mm-menu-open");
		document.querySelector("html").classList.toggle("stop-scrolling");
	}
}

/**
 * Close the mobile menu and revert UI changes.
 */
function mmCloseMobileMenu() {
	if (window.innerWidth <= 1200) {
		const header = document.querySelector("header");
		const icon = document.querySelector(".mm-header-burger");
		const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

		header.classList.remove("mm-open");
		icon.classList.remove("mm-open");
		document.querySelector("html").classList.toggle("stop-scrolling");
		mobileMenu.classList.remove("mm-menu-open");

		hideBgFilter();
	}
}

/**
 * Show the next sub-menu in the mobile menu.
 * @param {string} elemToShowClass - The class selector of the element to show.
 */
function mmMobileMenuShowNext(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

/**
 * Hide the current sub-menu in the mobile menu.
 * @param {string} elemToShowClass - The class selector of the element to hide.
 */
function mmMobileMenuShowPrev(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

// SEARCH //
/**
 * Show the search bar and related UI changes.
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
function mmShowSearch(clickedElem) {
	const search = document.querySelector('.mm-header-search-container');
	const filter = document.querySelector('.mm-filter-mega-menu');
	search.classList.add('mm-open');
	filter.classList.add("active");

	setTimeout(() => {
		document.getElementById('Search').focus();
	}, '1000');

	document.getElementById('predictive-search').addEventListener("touchstart", (event) => {
		setTimeout(() => {
			document.getElementById('Search').blur();
		}, 500);
	});
}

/**
 * Hide the search bar and revert UI changes.
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
function mmHideSearch(clickedElem) {
	const search = document.querySelector('.mm-header-search-container');
	const filter = document.querySelector('.mm-filter-mega-menu');
	search.classList.remove('mm-open');
	filter.classList.remove('active');

	var searchInput = document.getElementById('Search');
	searchInput.value = '';
	var event = new Event('input');
	searchInput.dispatchEvent(event);
}

// DROPDOWN //
/**
 * Handle dropdown behavior.
 */
function handleDropdown() {
    const dropWrapper = document.querySelectorAll('.mm-drop-wrapper');

    // Open the first dropdown by default
    // if (dropWrapper.length > 0) {
    //     dropWrapper[0].classList.add('active');
    //     dropWrapper[0].nextElementSibling.style.maxHeight = dropWrapper[0].nextElementSibling.scrollHeight + 'px';
    // }

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            dropWrapper.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    el.nextElementSibling.style.maxHeight = null;
                }
            });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

// CART //
/**
 * Set the document height custom property to handle mobile drawer height.
 */
const documentHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// SHARE LINKS //
/**
 * Copy the current URL to the clipboard and update the share text.
 */
function copierURL() {
    var url = window.location.href;
    var dummyInput = document.createElement("input");
    document.body.appendChild(dummyInput);
    dummyInput.setAttribute("value", url);
    dummyInput.select();
    document.execCommand("copy");
    document.body.removeChild(dummyInput);

    var copiedText = document.getElementById("shareText").getAttribute("data-copied-text");
    document.getElementById("shareText").textContent = copiedText;
}

// SLIDER ANIMATION //
/**
 * Handle the rotation of items in a carousel/slider on user interaction.
 */
function handleSliderRotation() {
	let progress = 50;
	let startX = 0;
	let active = 0;
	let isDown = false;

	const speedDrag = -0.2;

	const getZindex = (array, index) =>
		array.map((_, i) =>
			index === i ? array.length : array.length - Math.abs(index - i)
		);

	const $items = document.querySelectorAll(".carousel-item");
	const $cursors = document.querySelectorAll(".cursor");

	const displayItems = (item, index, active) => {
		const zIndex = getZindex([...$items], active)[index];
		const activeValue = (index - active) / $items.length;

		item.style.setProperty("--zIndex", zIndex);
		item.style.setProperty("--active", activeValue);
	};

	const animate = () => {
		progress = Math.max(0, Math.min(progress, 100));
		active = Math.floor(progress / 100 * ($items.length - 1));

		$items.forEach((item, index) => displayItems(item, index, active));
	};

	animate();

	const handleMouseMove = e => {
		if (e.type === "mousemove") {
			$cursors.forEach($cursor => {
				$cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
			});
		}
		if (!isDown) return;
		const x = e.clientX || e.touches && e.touches[0].clientX || 0;
		const mouseProgress = (x - startX) * speedDrag;
		progress = progress + mouseProgress;
		startX = x;
		animate();
	};

	const handleMouseDown = e => {
		isDown = true;
		startX = e.clientX || e.touches && e.touches[0].clientX || 0;
	};

	const handleMouseUp = () => {
		isDown = false;
	};

	if (window.innerWidth <= 768) {
		// document.addEventListener("mousewheel", handleWheel);
		document.addEventListener("mousedown", handleMouseDown);
		document.addEventListener("mousemove", handleMouseMove);
		document.addEventListener("mouseup", handleMouseUp);
		document.addEventListener("touchstart", handleMouseDown);
		document.addEventListener("touchmove", handleMouseMove);
		document.addEventListener("touchend", handleMouseUp);
	};
};

// ANIMATIONS //
// GSAP
gsap.registerPlugin(ScrollTrigger);

/**
 * Initialize lace pattern animations on scroll using GSAP.
 */
function intitLacePattern() {
	const patterns = document.querySelectorAll(".pattern");

	if (patterns) {
		patterns.forEach((pattern) => {
			gsap.to(pattern, {
			"--svg-offset": "0",
			scrollTrigger: {
				trigger: pattern,
				start: "top center+=150",
				end: "bottom center-=150",
				scrub: true,
				// markers: true
			}
			});
		});
	}
}

/**
 * Initialize parallax animations for images using GSAP.
 */
function initImageParallax() {
	const imageContainers = document.querySelectorAll(".slider-image-parallax");

	if (imageContainers) {
		imageContainers.forEach((imageContainer) => {
			gsap.to(imageContainer, {
				yPercent: -20,
				ease: "none",
				scrollTrigger: {
					trigger: imageContainer.parentNode, // Utilisation du parent comme déclencheur
					start: "top bottom",
					end: "bottom top",
					scrub: true
				}
			});
		});
	}
}

// splide menu mobile card
function mmInitSplideCardMobile() {
	const mainSplide = document.querySelector('.mm-splide-cards-mobile');
	if (mainSplide) {
		new Splide(mainSplide, {
			type: 'slide',
			arrows: false,
			pagination: false,
               autoWidth: true,
               drag: 'free',
               snap: true,
			gap: 12,
			perPage: 3,
               perMove: 1,
               width: 200,
               padding: {
               left: '20px',
               right: '0px'
               },
			breakpoints: {
				768: {
					perPage: 1,
					gap: 12
				}
			}
		}).mount();
	}
}

// splide menu mobile brand
function mmInitSplideBrandMobile() {
	const mainSplide = document.querySelector('.mm-splide-brand-mobile');
	if (mainSplide) {
		new Splide(mainSplide, {
			type: 'slide',
			arrows: false,
			pagination: false,
      autoWidth: true,
			gap: 12,
			perPage: 'auto',  // Changé de 1 à 'auto'
      padding: {
        left: '20px',
        right: '20px'
      },
      focus: 0,  // Ajouté pour définir le point de focus au début
      trimSpace: false,  // Ajouté pour éviter que Splide ne coupe l'espace vide
			breakpoints: {
				768: {
					perPage: 'auto',  // Changé aussi ici
					gap: 12
				}
			}
		}).mount();
	}
}


document.addEventListener("DOMContentLoaded", (event) => {
	getMegaMenuPosition();
	hoverBgFilter();
	intitLacePattern();
	handleSliderRotation();
	initImageParallax();
	handleDropdown();
	mmInitMobileMenu();
	externalLink();
  mmInitSplideCardMobile();
  mmInitSplideBrandMobile();
});

document.addEventListener("scroll", (event) => {
	mmInitMobileMenu();
});


window.addEventListener('resize', documentHeight)
documentHeight();


// PRODUCT RECO //
/**
 * Custom element to handle product recommendations lazy loading.
 */
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

// REPLACE "," by "." in decimal inputs
function replaceComma(input) {
    input.value = input.value.replace(',', '.');
}
